(() => {
  // app/scripts/common/component/cartNote.js
  var { fetch: fetch2, debounceTime } = theme;
  var CartNote = class extends HTMLElement {
    constructor() {
      super();
      const parent = this.closest(".cart-note-wrapper");
      this.querySelector("[name=note]")?.addEventListener("input", debounceTime((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch2(`${theme.routes.cartUrl}/update.js`, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": `application/json;`
          }
        });
      }, 1e3));
    }
  };
  customElements.define("cart-note", CartNote);

  // app/scripts/common/component/cartRemove.js
  var CartRemoveButton = class extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector("a");
      link.addEventListener("click", (event) => {
        try {
          event.preventDefault();
          let { key, sections, sections_url } = link.dataset;
          if (!key)
            return;
          sections = [sections];
          this.closest("cart-component,cart-drawer-component").dispatchEvent(new CustomEvent("change", {
            bubbles: true,
            detail: {
              customElement: {
                target: link,
                key,
                quantity: 0,
                sections,
                sections_url
              }
            }
          }));
        } catch (e) {
          console.log(e);
        }
      });
    }
  };
  customElements.define("cart-remove-button", CartRemoveButton);

  // app/scripts/common/component/cartUpdateComponent.js
  !customElements.get("cart-update-component") && customElements.define("cart-update-component", class extends cartForm {
    constructor() {
      super();
      this.addEventListener("change", (e) => {
        this.currentTarget = e.target;
        let { value } = this.currentTarget;
        if (this.currentTarget.type == "checkbox") {
          value = this.currentTarget.checked;
        }
        this.onUpdate(value);
        if (this.querySelector(".jsValue"))
          this.querySelector(".jsValue").innerHTML = value;
      });
    }
    onUpdate(value) {
      const attributes = { [this.dataset.type]: value };
      this.disabled = true;
      this.cartUpdate(attributes);
    }
    set disabled(value) {
      this.classList.toggle("event-none", value);
    }
    async onFinished() {
      this.updateState();
      this.disabled = false;
    }
    async updateState() {
      const { sectionId } = this.dataset;
      if (!sectionId)
        return;
      let url = location.href;
      url += url.includes("?") ? "&" : "?";
      url += sectionId;
      let html = await fetch(url);
      html = await html.text();
      const div = document.createElement("div");
      div.innerHTML = html;
      this.closest("filter-component")?.render(div);
      if (this.currentTarget.closest("details[open]"))
        this.currentTarget.closest("details[open]").open = false;
    }
  });

  // app/scripts/cart-drawer-component.js
  var { debounceTime: debounceTime2 } = theme;
  var cartDrawerComponent = class extends cartForm {
    constructor() {
      super();
      const debounce = debounceTime2((e) => this.onChange(e), 300);
      this.addEventListener("change", debounce.bind(this));
      this.addEventListener("change", this.checkTabindex());
      window.addEventListener("checkTabindex", () => {
        this.checkTabindex();
      });
    }
    set open(value) {
      const popup = this.closest("popup-component");
      if (value) {
        this.closeAllCurrentPopups();
        popup.open();
      } else
        popup.close();
    }
    set refresh(sections) {
      const div = document.createElement("div");
      div.innerHTML = sections[this.sectionName];
      this.innerHTML = div.querySelector(this.tagName).innerHTML;
    }
    checkTabindex() {
      this.getElementsByTagName("*").forEach((element) => {
        if (element.tabIndex >= 0 || ["INPUT", "TEXTAREA", "BUTTON", "SELECT"].includes(element.tagName)) {
          !element.getAttribute("data-default-tab") && element.setAttribute("data-default-tab", element.tabIndex);
          element.setAttribute("tabIndex", this.closest("popup-component").getAttribute("aria-hidden") === "true" ? element.getAttribute("data-default-tab") : -1);
        }
      });
    }
    closeAllCurrentPopups() {
      document.querySelectorAll("popup-component.active")?.forEach((popup) => {
        popup.close();
      });
    }
  };
  customElements.define("cart-drawer-component", cartDrawerComponent);
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".jsCartDrawer"))
      return;
    e.preventDefault();
    document.querySelector("cart-drawer-component").open = true;
  });
})();
